export const LATEST_ORGANIZATION_STORAGE_KEY = 'ls:ui:last_org_id';
